@if (breachModel) {
    <div>
        @if (BreachTimerText) {
            <div class="detail-page-summary">
                <div class="row">
                    <div class="col-4">
                        <div class="property">
                            <b>{{ 'breachDetail.summaryDateOccurred' | t }}</b>
                            {{ breachModel.BreachOccurenceDateTime | dateFormat }}
                        </div>
                        <div class="property">
                            <b>{{ 'breachDetail.summaryDateDetected' | t }}</b>
                            {{ breachModel.BreachDetectionDateTime | dateTimeFormat }}
                        </div>
                        <div class="property">
                            <b>{{ 'breachDetail.summaryDateEndBreach' | t }}</b> {{ breachModel.BreachEndDateTime | dateFormat }}
                        </div>
                    </div>
                    <div class="col timer">
                        {{ BreachTimerText }}
                    </div>
                </div>
            </div>
        }

        @if (eventModel) {
            <div class="detail-page-card">
                <div class="detail-page-card-actions">
                    <button
                        data-uiid="event-db-isdatabreach"
                        class="btn btn-raised"
                        (click)="toggleDataBreach()"
                        [disabled]="!eventPermissions.canSave || breachPermissions.readonly"
                    >
                        <i
                            class="{{
                                eventModel.IsDataBreach ? 'fas fa-check-square' : 'far fa-square'
                            }}"
                        ></i>
                        <span>{{ 'breachDetail.isDataBreachBtn' | t }}</span>
                    </button>
                </div>
            </div>
        }

        @if (isTogglingDataBreach) {
            <div class="fancy-loader"></div>
        }

        @if ((eventModel && eventModel.IsDataBreach) || breachModel.ID > 0) {
            <form
                [formGroup]="parentForm"
                novalidate
                class="cerrix-control-sm"
                [class.breach-disabled-overlay]="!eventModel.IsDataBreach"
            >
                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'breachDetail.breachDetailsTitle' | t }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="row">
                                            <div class="form-group col">
                                                <cerrix-textfield
                                                    fieldLabel="{{ 'breachDetail.internalBreachIdentifierFieldLabel' | t }}"
                                                    dataUiid="event-db-internalidentifier"
                                                    identifier="internalIdentifierInput"
                                                    formControlName="InternalBreachIdentifier"
                                                ></cerrix-textfield>
                                            </div>

                                            <div class="form-group col">
                                                <cerrix-textfield
                                                    fieldLabel="{{ 'breachDetail.externalBreachIdentifierFieldLabel' | t }}"
                                                    dataUiid="event-db-externalidentifier"
                                                    identifier="externalIdentifierInput"
                                                    formControlName="ExternalBreachIdentifier"
                                                ></cerrix-textfield>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <label for="organizationSelect">{{ 'breachDetail.organizationLabel' | t }}</label>
                                            <cerrix-select-tree
                                                data-uiid="event-db-organization"
                                                [tree]="sdHeavy.organizations"
                                                formControlName="OrganizationId"
                                                placeholder="Required"
                                                [multiselect]="false"
                                            >
                                            </cerrix-select-tree>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <label for="responsibleSelect"
                                                >{{ 'breachDetail.dataBreachResponsiblesLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-responsibles"
                                                id="breachResponsibleSelect"
                                                name="responsibleSelect"
                                                [items]="sdHeavy.responsibles"
                                                formControlName="ResponsibleList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                                placeholder="Required"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="assessorSelect"
                                                >{{ 'breachDetail.dataBreachAssessorsLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-assessors"
                                                id="breachAssessorSelect"
                                                name="assessorSelect"
                                                [items]="sdHeavy.assessors"
                                                formControlName="BreachAssessorList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="dataProtectionOfficerSelect"
                                                >{{ 'breachDetail.dataProtectionOfficerLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-protection"
                                                id="dataProtectionOfficerSelect"
                                                name="dataProtectionOfficerSelect"
                                                [items]="sdHeavy.officers"
                                                formControlName="DataProtectionOfficerId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <label>{{ 'breachDetail.dateBreachOccurredLabel' | t }}</label>
                                            <date-input
                                                data-uiid="event-db-dateoccured"
                                                formControlName="BreachOccurenceDateTime"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>

                                        <div class="form-group">
                                            <label>{{ 'breachDetail.dateBreachDetectedLabel' | t }}</label>
                                            <date-input
                                                data-uiid="event-db-datedetected"
                                                formControlName="BreachDetectionDateTime"
                                                (valueChange)="calculateDateTime()"
                                                [showTimePicker]="true"
                                                [maxDate]="maxDate"
                                            >
                                            </date-input>
                                        </div>

                                        <div class="form-group">
                                            <label>{{ 'breachDetail.dateEndOfBreachLabel' | t }}</label>
                                            <date-input
                                                data-uiid="event-db-dateendofbreach"
                                                formControlName="BreachEndDateTime"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'breachDetail.breachAnalysisTitle' | t }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <label for="breachCategorySelect"
                                                >{{ 'breachDetail.natureOfBreachLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-natureofbreach"
                                                id="breachCategorySelect"
                                                name="breachCategorySelect"
                                                [items]="sdHeavy.breachCategories"
                                                formControlName="BreachCategoryList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="natureOfIncidentSelect"
                                                >{{ 'breachDetail.natureOfIncidentLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-natureofincident"
                                                id="natureOfIncidentSelect"
                                                name="natureOfIncidentSelect"
                                                [items]="sdHeavy.natureOfIncidents"
                                                formControlName="NatureOfIncidentId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'breachDetail.descriptionOfBreachFieldLabel' | t }}"
                                                dataUiid="event-db-descriptionofbreach"
                                                identifier="breachDescriptionInput"
                                                formControlName="BreachDescription"
                                                placeholder="Required"
                                            ></cerrix-textarea>
                                        </div>

                                        <div class="form-group">
                                            <label for="typesOfBreachSelect">{{ 'breachDetail.typesOfBreachLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="event-db-typesofbreach"
                                                id="typesOfBreachSelect"
                                                name="typesOfBreachSelect"
                                                [items]="sdHeavy.breachTypes"
                                                formControlName="BreachTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [multiple]="true"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'breachDetail.causeOfBreachFieldLabel' | t }}"
                                                dataUiid="event-db-causeofbreach"
                                                identifier="causeOfbreachInput"
                                                formControlName="BreachCause"
                                                placeholder="Required"
                                            ></cerrix-textarea>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'breachDetail.preventativeMeasuresFieldLabel' | t }}"
                                                dataUiid="event-db-preventativemeasures"
                                                identifier="preventativeMeasuresInput"
                                                formControlName="PreventativeMeasures"
                                            ></cerrix-textarea>
                                        </div>

                                        <div class="form-group">
                                            <label for="ciaOfDataSelect"
                                                >{{ 'breachDetail.consequencesToCiaLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-consequencescia"
                                                id="ciaOfDataSelect"
                                                name="ciaOfDataSelect"
                                                [items]="sdHeavy.consequencesToCiaOfData"
                                                formControlName="ConsequencesToCiaOfDataList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [multiple]="true"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="personalBreachSelect"
                                                >{{ 'breachDetail.consequencesPersonalDataLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-consequencespersonal"
                                                id="personalBreachSelect"
                                                name="personalBreachSelect"
                                                [items]="sdHeavy.consequencesOfBreach"
                                                formControlName="DataBreachConsequences"
                                                [multiple]="true"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="personsInvolvedSelect"
                                                >{{ 'breachDetail.personsInvolvedLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-personsinvolved"
                                                id="personsInvolvedSelect"
                                                name="personsInvolvedSelect"
                                                [items]="sdHeavy.personsInvolvedTypes"
                                                formControlName="PersonsInvolvedList"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [multiple]="true"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textarea
                                                fieldLabel="{{ 'breachDetail.descriptionPersonsInvolvedFieldLabel' | t }}"
                                                dataUiid="event-db-descriptionpersonsinvolved"
                                                identifier="personsInvolvedInput"
                                                formControlName="PersonsInvolvedDescription"
                                            ></cerrix-textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>

                                        <div class="form-group">
                                            <label for="personalDataSelect">{{ 'breachDetail.personalDataLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="event-db-personaldata"
                                                id="personalDataSelect"
                                                name="personalDataSelect"
                                                [items]="sdHeavy.personalDataTypes"
                                                formControlName="PersonalDataTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                                placeholder="Required"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="specialCatPersonalDataSelect"
                                                >{{ 'breachDetail.specialCategoriesLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-specialcategories"
                                                id="specialCatPersonalDataSelect"
                                                name="specialCatPersonalDataSelect"
                                                [items]="sdHeavy.specialPersonalDataTypes"
                                                formControlName="SensitivePersonalDataTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.nameDataProcessorFieldLabel' | t }}"
                                                dataUiid="event-db-namedataprocessor"
                                                identifier="nameDataProcessorInput"
                                                formControlName="DataProcessorName"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 form-group">
                                                <cerrix-checkbox
                                                    data-uiid="event-db-outsourced"
                                                    formControlName="OutsourcedDataProcessing"
                                                    label="{{ 'breachDetail.outsourcedDataProcessingLabel' | t }}"
                                                    fontsize="0.9em"
                                                >
                                                </cerrix-checkbox>
                                            </div>
                                            <div class="col-6 form-group">
                                                <cerrix-checkbox
                                                    data-uiid="event-db-subdata"
                                                    formControlName="SubdataProcessor"
                                                    label="{{ 'breachDetail.subDataProcessorLabel' | t }}"
                                                    fontsize="0.9em"
                                                >
                                                </cerrix-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        <div class="form-group">
                                            <label for="dataregistersInvolvedNumber"
                                                >{{ 'breachDetail.numDataRegistersLabel' | t }}</label
                                            >
                                            <input
                                                data-uiid="event-db-numberdataregisters"
                                                type="number"
                                                class="form-control form-control-sm"
                                                id="dataregistersInvolvedNumber"
                                                formControlName="NumberOfDataRegistersInvolved"
                                                step="1"
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="minimumPersonsInvolvedNumber"
                                                >{{ 'breachDetail.minimumPersonsLabel' | t }}</label
                                            >
                                            <input
                                                data-uiid="event-db-minimumnumberofpersons"
                                                type="number"
                                                class="form-control form-control-sm"
                                                id="minimumPersonsInvolvedNumber"
                                                formControlName="NumberOfPersonsInvolvedMinimum"
                                                step="1"
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="maximumPersonsInvolvedNumber"
                                                >{{ 'breachDetail.maximumPersonsLabel' | t }}</label
                                            >
                                            <input
                                                data-uiid="event-db-maximumnumberofpersons"
                                                type="number"
                                                class="form-control form-control-sm"
                                                id="maximumPersonsInvolvedNumber"
                                                formControlName="NumberOfPersonsInvolvedMaximum"
                                                step="1"
                                            />
                                        </div>

                                        <div class="row">
                                            <div class="col form-group">
                                                <cerrix-checkbox
                                                    data-uiid="event-db-personsothereu"
                                                    formControlName="PersonsInvolvedFromOtherEuCountries"
                                                    label="{{ 'breachDetail.personsOtherEuLabel' | t }}"
                                                    fontsize="0.9em"
                                                >
                                                </cerrix-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'breachDetail.notificationsTitle' | t }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-authoritiesnotified"
                                                formControlName="AuthoritiesNotified"
                                            label="{{ 'breachDetail.authoritiesNotifiedLabel' | t }}"
                                                fontsize="0.9em"
                                                (valueChange)="authoritiesNotifiedChange($event)"
                                            >
                                            </cerrix-checkbox>
                                        </div>

                                        @if (parentForm.controls.AuthoritiesNotified.value) {
                                            <div class="form-group">
                                                <label>{{ 'breachDetail.dateAuthoritiesNotifiedLabel' | t }}</label>
                                                <date-input
                                                    data-uiid="event-db-dateauthoritiesnotified"
                                                    formControlName="AuthoritiesNotifiedDate"
                                                    (valueChange)="calculateDateTime()"
                                                    [showTimePicker]="true"
                                                    [maxDate]="maxDate"
                                                >
                                                </date-input>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-xl-none"></div>
                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-intauthoritiesnotified"
                                                formControlName="InternationalAuthoritiesNotified"
                                            label="{{ 'breachDetail.intAuthoritiesNotifiedLabel' | t }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>
                                        @if (
                                            parentForm.controls.InternationalAuthoritiesNotified
                                                .value
                                        ) {
                                            <div class="form-group">
                                                <cerrix-textfield
                                                    fieldLabel="{{ 'breachDetail.nameIntAuthFieldLabel' | t }}"
                                                    dataUiid="event-db-nameinternationalauthority"
                                                    identifier="nameInternationalAuthority"
                                                    formControlName="InternationalAuthoritiesName"
                                                ></cerrix-textfield>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>
                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.whichEuCountryFieldLabel' | t }}"
                                                dataUiid="event-db-whicheucountry"
                                                identifier="whichEuCountryInput"
                                                formControlName="EUCountry"
                                            ></cerrix-textfield>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-crossborderprocessing"
                                                formControlName="CrossborderProcessing"
                                            label="{{ 'breachDetail.crossborderProcessingLabel' | t }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>

                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-notificationpersonsinvolved"
                                                formControlName="PersonsInvolvedNotified"
                                            label="{{ 'breachDetail.notificationPersonsInvolvedLabel' | t }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>

                                        @if (parentForm.controls.PersonsInvolvedNotified.value) {
                                            <div class="form-group">
                                                <label for="personsInvNotDate"
                                                    >{{ 'breachDetail.dateNotificationPersonsLabel' | t }}</label
                                                >
                                                <date-input
                                                    data-uiid="event-db-datenotifications"
                                                    formControlName="PersonsInvolvedNotificationDate"
                                                    [maxDate]="maxDate"
                                                >
                                                </date-input>
                                            </div>

                                            <div class="form-group">
                                                <label for="personsInvolvedNotifiedNumber"
                                                    >{{ 'breachDetail.numPersonsNotifiedLabel' | t }}</label
                                                >
                                                <input
                                                    data-uiid="event-db-numberpersonsnotified"
                                                    type="number"
                                                    class="form-control form-control-sm"
                                                    id="personsInvolvedNotifiedNumber"
                                                    name="personsInvolvedNotifiedNumber"
                                                    formControlName="PersonsNotified"
                                                    min="0"
                                                />
                                            </div>
                                        } @else {
                                            <div class="form-group">
                                                <label for="reasonNoNotificationSelect"
                                                    >{{ 'breachDetail.reasonNoNotificationLabel' | t }}</label
                                                >
                                                <ng-select
                                                    data-uiid="event-db-reasonnonotification"
                                                    id="reasonNoNotificationSelect"
                                                    name="reasonNoNotificationSelect"
                                                    [items]="sdHeavy.noNotificationReasons"
                                                    formControlName="ReasonNoNotificationId"
                                                    bindLabel="Name"
                                                    bindValue="ID"
                                                    [closeOnSelect]="true"
                                                    [multiple]="false"
                                                >
                                                </ng-select>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        @if (parentForm.controls.PersonsInvolvedNotified.value) {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'breachDetail.descriptionNotificationFieldLabel' | t }}"
                                                    dataUiid="event-db-descriptionnotification"
                                                    identifier="personsInvNotiDescr"
                                                    formControlName="NotificationPersonsInvolved"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        } @else {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'breachDetail.explanationNoNotificationFieldLabel' | t }}"
                                                    dataUiid="event-db-explanationnonotification"
                                                    identifier="personsInvNoNotiExpl"
                                                    formControlName="ExplanationNoNotificationPersonsInvolved"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        }

                                        @if (parentForm.controls.PersonsInvolvedNotified.value) {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'breachDetail.meansOfCommunicationFieldLabel' | t }}"
                                                    dataUiid="event-db-meansofcommunication"
                                                    identifier="meansOfCommunicationInput"
                                                    formControlName="MeansOfCommunication"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group-separator"></div>

                                        <div class="form-group">
                                            <cerrix-checkbox
                                                data-uiid="event-db-secondarynotification"
                                                formControlName="SecondaryNotificationNotified"
                                            label="{{ 'breachDetail.secondaryNotificationLabel' | t }}"
                                                fontsize="0.9em"
                                            >
                                            </cerrix-checkbox>
                                        </div>

                                        @if (parentForm.controls.SecondaryNotificationNotified) {
                                            <div class="form-group">
                                                <label for="secondaryNotDate"
                                                    >{{ 'breachDetail.dateSecondaryNotificationLabel' | t }}</label
                                                >
                                                <date-input
                                                    data-uiid="event-db-datesecondarynotification"
                                                    formControlName="SecondaryNotificationDate"
                                                    [maxDate]="maxDate"
                                                >
                                                </date-input>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group-separator d-none d-xl-block"></div>

                                        @if (parentForm.controls.SecondaryNotificationNotified) {
                                            <div class="form-group">
                                                <cerrix-textarea
                                                    fieldLabel="{{ 'breachDetail.descriptionSecondaryNotificationFieldLabel' | t }}"
                                                    dataUiid="event-db-descriptionsecondarynotification"
                                                    identifier="secondaryNotifiDescr"
                                                    formControlName="SecondaryNotificationDescription"
                                                >
                                                </cerrix-textarea>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'breachDetail.contactDetailsTitle' | t }}</div>
                    <div class="detail-page-card-body padded">
                        @if (sdHeavy) {
                            <div>
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.cocRegistrationNrFieldLabel' | t }}"
                                                dataUiid="event-db-cocnumber"
                                                identifier="cocRegistrationNumberInput"
                                                formControlName="RegistrationNr"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.organizationNameFieldLabel' | t }}"
                                                dataUiid="event-db-organizationname"
                                                identifier="organizationNameInput"
                                                formControlName="OrganizationName"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <label for="activeSectorSelect"
                                                >{{ 'breachDetail.activeInWhichSectorLabel' | t }}</label
                                            >
                                            <ng-select
                                                data-uiid="event-db-activeinsector"
                                                id="activeSectorSelect"
                                                name="activeSectorSelect"
                                                [items]="sdHeavy.whichSectors"
                                                formControlName="ActiveInWhichSectorId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="true"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.zipCodeFieldLabel' | t }}"
                                                dataUiid="event-db-zipcode"
                                                identifier="zipCodeInput"
                                                formControlName="ZipCode"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.cityFieldLabel' | t }}"
                                                dataUiid="event-db-city"
                                                identifier="cityInput"
                                                formControlName="City"
                                            ></cerrix-textfield>
                                        </div>

                                        <div class="form-group">
                                            <cerrix-textfield
                                                fieldLabel="{{ 'breachDetail.addressFieldLabel' | t }}"
                                                dataUiid="event-db-address"
                                                identifier="addressInput"
                                                formControlName="Address"
                                            ></cerrix-textfield>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                </div>

                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'breachDetail.additionalInformationTitle' | t }}</div>
                    <div class="detail-page-card-body padded">
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="form-group">
                                    <cerrix-textarea
                                        fieldLabel="{{ 'breachDetail.followUpDescriptionFieldLabel' | t }}"
                                        dataUiid="event-db-followupdescription"
                                        identifier="followUpDescriptionInput"
                                        formControlName="FollowUpDescription"
                                    >
                                    </cerrix-textarea>
                                </div>
                            </div>

                            <div class="col-12 col-xl-6 right-block">
                                <div class="form-group">
                                    <cerrix-textarea
                                        fieldLabel="{{ 'breachDetail.commentsFieldLabel' | t }}"
                                        dataUiid="event-db-comments"
                                        identifier="commentsInput"
                                        formControlName="Comments"
                                    ></cerrix-textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Custom fields -->
                @if (showCustomFields) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">{{ 'breachDetail.customFieldsTitle' | t }}</div>
                        <div
                            class="detail-page-card-body padded form-group-styling cerrix-control-sm"
                        >
                            <cerrix-custom-fields-editor
                                [parentForm]="databreachCustomFieldsFormGroup"
                                [customFieldData]="databreachCustomFieldData"
                                [singleColumn]="false"
                            ></cerrix-custom-fields-editor>
                        </div>
                    </div>
                }
            </form>
        }
    </div>
} @else {
    <div class="fancy-loader"></div>
}
